import { useMemo } from "react";
import { FaBell, FaBellSlash } from "react-icons/fa";

const getTodaySlot = (operator) => {
  const now = new Date();
  const currentDay = now.toLocaleDateString("en-US", { weekday: "long" });
  const today = operator?.openingHours?.find((d) => d.day === currentDay);
  const nowMins = now.getHours() * 60 + now.getMinutes();

  if (!today || !today.slots?.length) return null;

  const slot = today.slots[0];
  const [openH, openM] = slot.open.split(/[:\s]/);
  const [closeH, closeM] = slot.close.split(/[:\s]/);
  const open24 = (+openH % 12) + (slot.open.includes("pm") ? 12 : 0);
  const close24 = (+closeH % 12) + (slot.close.includes("pm") ? 12 : 0);
  const openTime = open24 * 60 + +openM;
  const closeTime = close24 * 60 + +closeM;

  const isOpen = nowMins >= openTime && nowMins < closeTime;

  return {
    isOpen,
    open: slot.open,
    close: slot.close,
  };
};

const TodayOpeningSlot = ({ operator }) => {
  const status = useMemo(() => getTodaySlot(operator), [operator]);

  return (
    <div className="text-sm mb-2 flex items-center gap-2">
      {status?.isOpen ? (
        <FaBell className="w-4 h-4 animate-vibrate animate-flash text-green-400" />
      ) : (
        <FaBellSlash className="w-4 h-4 animate-vibrate animate-flash text-red-400" />
      )}
      {status?.isOpen ? (
        <>
          <span className="text-green-500 font-medium">Open now</span>
          <span className="text-textGray">until {status.close}</span>
        </>
      ) : (
        <>
          <span className="text-redlight font-medium">Closed</span>
          <span className="text-textGray">opens at {status?.open}</span>
        </>
      )}
    </div>
  );
};

export default TodayOpeningSlot;
